module.exports = __webpack_public_path__ + "static/media/rm4.9a5727ae.jpg";